export default "__VITE_ASSET__XxGJpEvY__"